import React from "react";
import ProgressBar from "./ProgressBar/ProgressBar";
import BadgesBar from "./BadgesBar/BadgesBar";
import FocusBadges from "./FocusBadges/FocusBadges";

const StreaksCard = () => {
  return (
    <div
      className="
        w-full max-w-[652px] bg-white rounded-2xl shadow-sm flex flex-col
        pt-[45px] px-[54px] pb-6
      "
    >
      {/* Top banner ProgressBar */}
      <ProgressBar />

      {/* Content area */}
      <div className="flex flex-col flex-1 mt-6 space-y-6">
        {/* Badges row */}
        <div className="flex items-center justify-center">
          <BadgesBar />
        </div>

        {/* Focus badges directly below, same center alignment */}
        <div className="flex items-center justify-center">
          <FocusBadges />
        </div>
      </div>

      {/* Footer */}
      <div className="text-xs text-gray-500 text-right"></div>
    </div>
  );
};

export default StreaksCard;
